/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "src/@/components/ui/dialog";
import { Label } from "src/@/components/ui/label";
import { Switch } from "src/@/components/ui/switch";
import { Textarea } from 'src/@/components/ui/textarea';

ModalChatGpt.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    chatGptStatus: PropTypes.bool,
    changeStatusIntegracao: PropTypes.func,
    instrucaoChatgpt: PropTypes.string,
    changeInstrucaoChatgpt: PropTypes.func,
    onSubmit: PropTypes.func
};

export default function ModalChatGpt({ open, onClose, chatGptStatus, changeStatusIntegracao, instrucaoChatgpt, changeInstrucaoChatgpt, onSubmit }) {
    const { t } = useTranslation('settings');

    return (
        <Dialog open={open} onOpenChange={(val) => !val && onClose()}>
            <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden bg-white rounded-xl shadow-2xl border border-gray-100">
                <DialogHeader className="p-6 pb-2">
                    <DialogTitle className="text-xl font-bold text-gray-900">{t('integrations.copilot.modalTitle', 'Copilot - Configurações')}</DialogTitle>
                </DialogHeader>
                <div className="px-6 py-4 flex flex-col gap-6">
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-100">
                        <Label htmlFor="status-mode" className="text-base font-semibold text-gray-700">
                            {t('integrations.copilot.enableLabel', 'Ativar Integração')}
                        </Label>
                        <Switch id="status-mode" checked={chatGptStatus} onCheckedChange={(checked) => changeStatusIntegracao({ target: { checked } })} />
                    </div>
                    {chatGptStatus && (
                        <div className="space-y-3">
                            <Label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                {t('integrations.copilot.systemPromptLabel', 'Prompt do Sistema')}
                            </Label>
                            <Textarea
                                value={instrucaoChatgpt}
                                onChange={changeInstrucaoChatgpt}
                                className="min-h-[200px] rounded-xl bg-[#F9FAFB] border-gray-200 focus:border-[#7C3AED] focus:ring-0 resize-none text-sm leading-relaxed"
                                placeholder={t('integrations.copilot.promptPlaceholder', 'Ex: Você é um assistente virtual útil e amigável da empresa X...')}
                            />
                        </div>
                    )}
                </div>
                <DialogFooter className="p-6 pt-2 bg-white gap-2">
                    <Button variant="ghost" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 rounded-lg">
                        {t('buttons.cancel', { ns: 'common' })}
                    </Button>
                    <Button onClick={onSubmit} className="px-6 py-2 text-sm font-medium text-white bg-[#7C3AED] hover:bg-[#6d28d9] rounded-lg shadow-sm shadow-[#7C3AED]/20 hover:scale-[1.02] transition-transform">
                        {t('buttons.saveChanges', { ns: 'common' })}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
